import { coverageRemodelingRowTotal, positiveCoverageAmount } from './coverageRemodelingSimulation'

const CANCER_COLUMNS = [
  { group: '진단', key: 'general-diagnosis', label: '일반암 진단', tone: 'diagnosis' },
  { group: '진단', key: 'similar-diagnosis', label: '유사암 진단', tone: 'diagnosis' },
  { group: '수술', key: 'general-surgery', label: '일반암수술', tone: 'surgery' },
  { group: '수술', key: 'robot-surgery', label: '로봇암수술', tone: 'surgery' },
  { group: '항암약물치료', key: 'chemical-drug', label: '화학항암약물', tone: 'drug' },
  { group: '항암약물치료', key: 'target-covered', label: '표적(급여)', tone: 'drug' },
  { group: '항암약물치료', key: 'target-non-covered', label: '표적(비급여)', tone: 'drug' },
  { group: '항암방사선치료', key: 'general-radiation', label: '일반 방사선', tone: 'radiation' },
  { group: '항암방사선치료', key: 'intensity-radiation', label: '세기조절', tone: 'radiation' },
  { group: '항암방사선치료', key: 'proton', label: '양성자', tone: 'radiation' },
  { group: '항암방사선치료', key: 'heavy-ion', label: '중입자', tone: 'radiation' },
]

const CARDIO_COLUMNS = [
  { group: '진단', key: 'brain-diagnosis', label: '뇌혈관질환', tone: 'diagnosis' },
  { group: '진단', key: 'heart-diagnosis', label: '심장질환', tone: 'diagnosis' },
  { group: '수술', key: 'brain-surgery', label: '뇌혈관수술', tone: 'surgery' },
  { group: '수술', key: 'heart-surgery', label: '심혈관수술', tone: 'surgery' },
  { group: '수술', key: 'circulatory-surgery', label: '순환계 수술', tone: 'surgery' },
  { group: '중환자실치료', key: 'circulatory-icu', label: '순환계 중환자실', tone: 'intensive' },
  { group: '혈전치료', key: 'thrombolysis', label: '혈전용해치료', tone: 'thrombus' },
  { group: '혈전치료', key: 'thrombectomy', label: '혈전제거치료', tone: 'thrombus' },
]

const CANCER_ROWS = [
  treatmentRow(['GENERAL_CANCER', 'CANCER_GENERAL'], '일반암', ['일반암', '암진단'], ['general-diagnosis']),
  treatmentRow(['SIMILAR_CANCER', 'CANCER_SIMILAR'], '유사암', ['유사암', '소액암'], ['similar-diagnosis']),
  treatmentRow(['CRITICAL_CANCER'], '중대한암', ['중대한암'], ['general-diagnosis']),
  treatmentRow(['HIGH_VALUE_CANCER'], '고액암/특정암', ['고액암', '특정암'], ['general-diagnosis']),
  treatmentRow(['CANCER_SURGERY'], '암수술', ['암수술'], ['general-surgery', 'robot-surgery']),
  treatmentRow(['DISEASE_TYPE_SURGERY'], '질병 종 수술비', ['질병 종 수술', '질병종수술'], ['general-surgery', 'robot-surgery']),
  treatmentRow(['CANCER_RADIATION_DRUG'], '항암방사선/약물', ['항암방사선', '항암약물'], ['chemical-drug', 'general-radiation']),
  treatmentRow(['TARGET_CANCER_TREATMENT'], '표적항암치료비', ['표적항암'], ['target-covered', 'target-non-covered']),
  treatmentRow(['PROTON_CANCER_TREATMENT'], '양성자', ['양성자'], ['proton']),
  treatmentRow(['HEAVY_ION_CANCER_TREATMENT'], '중입자', ['중입자'], ['heavy-ion']),
  treatmentRow(['CANCER_MAJOR_TREATMENT'], '암주요치료비', ['암주요치료', '주요치료비'], [
    'general-surgery', 'robot-surgery', 'chemical-drug', 'target-covered', 'target-non-covered',
    'general-radiation', 'intensity-radiation', 'proton', 'heavy-ion',
  ]),
  treatmentRow(['NON_COVERED_CANCER_MAJOR_TREATMENT'], '비급여 암주요치료비', ['비급여 암주요치료'], [
    'robot-surgery', 'target-non-covered', 'proton', 'heavy-ion',
  ]),
]

const CARDIO_ROWS = [
  treatmentRow(['BRAIN_VESSEL', 'BRAIN_VASCULAR'], '뇌혈관', ['뇌혈관'], ['brain-diagnosis']),
  treatmentRow(['UNRUPTURED_CEREBRAL_ANEURYSM'], '뇌동맥류(비파열성)', ['뇌동맥류', '비파열성'], ['brain-diagnosis']),
  treatmentRow(['STROKE'], '뇌졸중', ['뇌졸중'], ['brain-diagnosis']),
  treatmentRow(['BRAIN_HEMORRHAGE'], '뇌출혈', ['뇌출혈'], ['brain-diagnosis']),
  treatmentRow(['SPECIFIC_CARDIOVASCULAR'], '특정심혈관질환', ['특정심혈관'], ['heart-diagnosis']),
  treatmentRow(['ARRHYTHMIA'], '부정맥', ['부정맥'], ['heart-diagnosis']),
  treatmentRow(['ANGINA'], '협심증', ['협심증'], ['heart-diagnosis']),
  treatmentRow(['ISCHEMIC_HEART'], '허혈심장질환', ['허혈심장', '허혈성심장'], ['heart-diagnosis']),
  treatmentRow(['ACUTE_MYOCARDIAL'], '급성심근경색', ['급성심근경색'], ['heart-diagnosis']),
  treatmentRow(['CARDIO_BRAIN_SURGERY'], '뇌혈관·허혈성심장 수술비', ['뇌혈관수술', '허혈성심장수술'], ['brain-surgery', 'heart-surgery']),
  treatmentRow(['CIRCULATORY_MAJOR_TREATMENT'], '순환계질환 주요 치료비', ['순환계질환', '순환계 주요치료'], [
    'brain-surgery', 'heart-surgery', 'circulatory-surgery', 'circulatory-icu', 'thrombolysis', 'thrombectomy',
  ]),
]

function treatmentRow(codes, label, nameTokens, stages) {
  return { codes, label, nameTokens, stages }
}

function normalizeSearchText(value) {
  return String(value || '').replace(/\s+/g, '').toLowerCase()
}

function findSourceRow(rows, definition) {
  const safeRows = Array.isArray(rows) ? rows : []
  const codes = new Set(definition.codes.map((code) => String(code).toUpperCase()))
  const byCode = safeRows.find((row) => codes.has(String(row?.coverageCode || '').trim().toUpperCase()))
  if (byCode) return byCode
  const tokens = definition.nameTokens.map(normalizeSearchText).filter(Boolean)
  return safeRows.find((row) => {
    const name = normalizeSearchText(row?.coverageName)
    return tokens.some((token) => name.includes(token))
  }) || null
}

function buildDefinition(kind) {
  if (kind === 'cancer') {
    return { title: '암 치료 단계별 보험금 수령액', columns: CANCER_COLUMNS, rows: CANCER_ROWS }
  }
  return { title: '뇌·심장 치료 단계별 보험금 수령액', columns: CARDIO_COLUMNS, rows: CARDIO_ROWS }
}

export function buildCoverageTreatmentStage(kind, rows, hasRemodelingPlans = false) {
  const definition = buildDefinition(kind)
  const stageRows = definition.rows.map((item) => {
    const source = findSourceRow(rows, item)
    const beforeAmount = positiveCoverageAmount(source?._beforeAmount ?? source?.totalAmount)
    const afterAmount = source ? coverageRemodelingRowTotal(source) : 0
    const activeAmount = hasRemodelingPlans ? afterAmount : beforeAmount
    return {
      ...item,
      source,
      beforeAmount,
      afterAmount,
      activeAmount,
      cells: definition.columns.map((column) => ({
        ...column,
        linked: item.stages.includes(column.key),
        amount: item.stages.includes(column.key) ? activeAmount : 0,
      })),
    }
  })
  const totals = definition.columns.map((column) => stageRows.reduce(
    (sum, row) => sum + (row.stages.includes(column.key) ? row.activeAmount : 0),
    0,
  ))
  return { ...definition, rows: stageRows, totals, hasRemodelingPlans }
}

